import AbsComponent from "../../common/AbsComponent";

/**
* SpecialBanner class
* @category main
*/
class SpecialBanner extends AbsComponent{
    constructor(_store={}, _el=''){
        super(_store, _el);

        this.setting();
        this.addEvents();
    }

    setting(){
        const slickOption = {
            dots: true,
            infinite: false,
            speed: 300,
            slidesToShow: 2,
            slidesToScroll: 2,
            responsive: [
                {
                    breakpoint: 4000,
                    settings: "unslick"
                },
                {
                    breakpoint: 960,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 2
                    }
                },
                {
                    breakpoint: 640,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1
                    }
                }
            ]
        };
        $(this.el + ' .special-banner-list').slick(slickOption);

        window.addEventListener("resize", ()=>{
            if(window.innerWidth < 960 && $(this.el + ' .special-banner-list').slick('getSlick').unslicked) {
                $(this.el + ' .special-banner-list').slick(slickOption);
            }
        });
    }

    addEvents(){
        $(this.el + ' .special-banner-video-link').on("click", (e)=>{
            let current_youtubeid = e.currentTarget.getAttribute('data-youtubeid');
            $('.center-modal-wrap#video-modal iframe').attr('src','https://www.youtube.com/embed/' + current_youtubeid);
            $('.center-modal-wrap#video-modal').addClass('is-show');
            return false;
        });// 스패셜 배너의 동영상 링크 클릭 되면 모달창 띄우기(서브 아이템이 없을 경우)

        $(this.el + ' .special-banner-item.is-video .item-link').on("click", (e)=>{
            
            const parentElement = /** @type {HTMLElement} */ (e.currentTarget.parentNode);
            let current_youtubeid = parentElement.getAttribute('data-youtubeid');

            $('.center-modal-wrap#video-modal iframe').attr('src','https://www.youtube.com/embed/' + current_youtubeid);
            $('.center-modal-wrap#video-modal').addClass('is-show');
            return false;
        });// 스패셜 배너의 동영상형 아이템이 클릭 되면 모달창 띄우기

        $(this.el + ' .center-modal .btn-close').on("click", (e)=>{
            $('.center-modal-wrap').removeClass('is-show');
            $('.center-modal-wrap#video-modal iframe').attr('src','');
        }); // 모달 레이어 닫고 iframe src 초기화
    }
} // end of class
export default SpecialBanner;